/* Imports */
import {
  onMounted,
  onUnmounted,
  ref,
} from 'vue';
import {
  useDebounceFn,
  useWindowSize,
} from '@vueuse/core';

export const useScreenSize = () => {
  const { width } = useWindowSize();

  // Set value on initialization
  const screenSizeWidth = ref(width.value);

  const debouncedUpdate = useDebounceFn(() => {
    screenSizeWidth.value = width.value;
  }, 300);

  // Update value on resize
  onMounted(() => window.addEventListener('resize', debouncedUpdate));
  onUnmounted(() => window.removeEventListener('resize', debouncedUpdate));

  return { screenSizeWidth };
};

export default useScreenSize;
